import { Link } from "react-router";
import { useSidebar } from "../sidebar";

/**
 * The mark on its own. 20px wide, so its centre sits 10px in — what the header
 * lines up against the timeline's spine.
 */
export function BrandDiamond() {
  return (
    <svg
      className="w-[20px] h-[20px] flex-shrink-0"
      viewBox="0 0 46 46"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="11.2"
        y="11.2"
        width="23.6"
        height="23.6"
        rx="4"
        transform="rotate(45 23 23)"
        fill="var(--primary)"
      />
      <path
        d="M23 6.5 L23 23 L6.5 23 Z"
        transform="rotate(45 23 23)"
        fill="color-mix(in oklch, var(--primary), white 26%)"
      />
    </svg>
  );
}

/**
 * The brand as the time sidebar's own header: the mark closes the panel, the
 * wordmark links home.
 *
 * The mark is the same control in both states — it collapses the sidebar from
 * here and reopens it from the header's time button, in the same spot either
 * way. `useSidebar()` rather than `useTimeSidebarToggle()` because this lives
 * inside the panel's own provider, so it also closes the sheet on mobile
 * (where the shared hook only ever opens).
 */
export default function BrandMark() {
  const { toggleSidebar } = useSidebar();

  return (
    <>
      <button
        type="button"
        onClick={toggleSidebar}
        title="Hide time (⌘B)"
        className="flex items-center rounded-md cursor-pointer"
      >
        <BrandDiamond />
        <span className="sr-only">Hide time sidebar</span>
      </button>
      <Link to="/">
        <span
          className="text-[20px] font-semibold tracking-[.005em] text-foreground"
          style={{ fontFamily: "var(--font-serif)" }}
        >
          Eventera
        </span>
      </Link>
    </>
  );
}
